import React from 'react';
import { ImagePreview } from '@tencent/tea-component';
export function BuyImagePreview(_a) {
    var previewSrc = _a.previewSrc, src = _a.src, children = _a.children, previewTitle = _a.previewTitle;
    return (React.createElement("div", { className: "tea-for-pay" },
        React.createElement("div", { className: "tea-form" },
            React.createElement(ImagePreview, { previewSrc: previewSrc, src: src, previewTitle: previewTitle }, children))));
}
//# sourceMappingURL=BuyImagePreview.js.map